import React from 'react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

const ConfirmationModal = ({ isOpen, onClose, title, message, type = 'success', companyEmails = [] }) => {
  if (!isOpen) return null;

  const isSuccess = type === 'success';
  const modalBgClass = isSuccess ? 'bg-green-100 border-green-500' : 'bg-red-100 border-red-500';
  const iconColorClass = isSuccess ? 'text-green-500' : 'text-red-500';
  const buttonClass = isSuccess ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[9999]">
      <div className={`relative bg-white rounded-xl p-8 shadow-2xl w-11/12 md:w-1/3 transform transition-all duration-300 scale-100 opacity-100 border-t-4 ${modalBgClass}`}>
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 text-2xl font-bold focus:outline-none"
        >
          &times;
        </button>
        <div className="flex flex-col items-center text-center">
          {isSuccess ? (
            <FaCheckCircle className={`text-6xl mb-4 ${iconColorClass}`} />
          ) : (
            <FaTimesCircle className={`text-6xl mb-4 ${iconColorClass}`} />
          )}
          <h2 className="text-3xl font-bold text-gray-800 mb-3">{title}</h2>
          <p className="text-gray-600 mb-6 text-lg">{message}</p>

          {!isSuccess && companyEmails.length > 0 && (
            <div className="mb-6 p-4 bg-red-50 rounded-lg border border-red-200">
              <p className="text-red-700 font-semibold mb-2">Please try again later or contact us directly:</p>
              {companyEmails.map((email, index) => (
                <a key={index} href={`mailto:${email}`} className="block text-blue-600 hover:underline text-md">
                  {email}
                </a>
              ))}
            </div>
          )}

          <button
            onClick={onClose}
            className={`mt-4 w-full md:w-auto px-8 py-3 rounded-lg text-white font-semibold shadow-md transition duration-300 ${buttonClass}`}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;